angular
    .module('tradersyard')
    .controller('notification-widget-ctrl', [
        '$scope',
        'graph-notification-factory',
        '$flex',
        'WebSocket',
        'NativeNotificationService',
        'NativeNotificationParamsService',
        function (
            $scope,
            notificationFactory,
            $flex,
            webSocket,
            NativeNotificationService,
            NativeNotificationParamsService
        ) {
            // region: variable initialization
            $scope.unreadCount = 0;
            $scope.collection = [];
            $scope.settings = {};
            $scope.preloader = false;

            var params = {
                page: 0,
                let: 0,
            };

            $scope.notificationSettingsType = {};

            $scope.notificationMessageType = {
                PostLiked: 0,
                CommentLiked: 1,
                PostPostedUser: 2,
                PostPostedGroup: 3,
                PostPostedWorkshop: 4,
                PostCommented: 5,
                InviteSentToWebinar: 6,
                InviteSentToGroup: 7,
                InviteSentToEvent: 8,
                RequestSent: 9,
                MessageSent: 10,
            };

            $scope.notificationMessage = [
                'liked your post.',
                'liked your comment.',
                'posted a new post in personal timeline.',
                'posted a new post in office.',
                'posted a new post in workshop.',
                'commented on your post.',
                'invited you to attend the event.',
                'invited you to join the office.',
                'invited you to attend the event.',
                'sent you a friend request.',
                'sent you a private message.',
            ];

            $scope.notificationUrlMap = [
                '/post/',
                '/post/',
                '/post/',
                '/post/',
                '/post/',
                '/post/',
                '/webinar/',
                '/group/',
                '/event/',
                '/',
                '/meeting/',
            ];

            angular.extend($scope, $flex.data);

            // endregion

            notificationFactory.readSettings('me').then(function (response) {
                $scope.settings = response.data.data;
            });

            notificationFactory
                .unread('me')
                .then(function (response) {
                    if (response.status === 200) {
                        $scope.unreadCount = response.data.total;
                    }
                })
                .catch(function () {
                    //
                });

            $scope.$on('touch:toolbox:notification', function () {
                $scope.query();
            });

            $scope.openNotificationPopup = function (dropdown) {
                if ($scope.unreadCount > 0) {
                    $scope.unreadCount = 0;
                    notificationFactory.markAllAsRead('me');
                }

                return dropdown === 'head.notification' ? undefined : 'head.notification';
            };

            $scope.readThenGo = function (itemId, url) {
                notificationFactory
                    .markAsRead('me', itemId)
                    .then(function (response) {
                        window.location = url;
                    })
                    .catch(function () {
                        window.location = url;
                    });
            };

            $scope.isNotificationEnable = function (notification, type) {
                // 'comment'
                // 'post'
                // 'invite'
                // 'request'
                // 'message'
                return true;
            };

            $scope.getNotificationType = function (notification) {
                switch (notification.verb.name) {
                    case 'liked':
                        return notification.object.name === 'comment'
                            ? $scope.notificationMessageType.CommentLiked
                            : $scope.notificationMessageType.PostLiked;
                    case 'posted':
                        if (notification.object.location.place.name === 'user') {
                            return $scope.notificationMessageType.PostPostedUser;
                        } else if (item.object.location.place.name === 'workshop') {
                            return $scope.notificationMessageType.PostPostedWorkshop;
                        } else {
                            return $scope.notificationMessageType.PostPostedGroup;
                        }
                        break;
                    case 'commented':
                        return $scope.notificationMessageType.PostCommented;
                    case 'sent':
                        if (notification.object.name === 'invite') {
                            if (notification.object.location.place.name === 'webinar') {
                                return $scope.notificationMessageType.InviteSentToWebinar;
                            } else if (notification.object.location.place.name === 'group') {
                                return $scope.notificationMessageType.InviteSentToGroup;
                            } else {
                                return $scope.notificationMessageType.InviteSentToEvent;
                            }
                        } else if (notification.object.name === 'request') {
                            return $scope.notificationMessageType.RequestSent;
                        } else {
                            return $scope.notificationMessageType.MessageSent;
                        }
                }
            };

            $scope.query = function (next, data) {
                ++params.page;
                $scope.preloader = true;
                notificationFactory
                    .query('me', { params: params })
                    .then(function (response) {
                        if (response.data.data.length > 0) {
                            $scope.collection = $scope.collection.concat(response.data.data);

                            $scope.updateUnreadCounter();
                            $scope.preloader = false;
                            next(data);
                        }
                    })
                    .finally(function () {
                        $scope.preloader = false;
                    });
            };

            $scope.updateUnreadCounter = function () {
                $scope.unreadCount = 0;

                $scope.collection.forEach(function (item, index) {
                    if (item.unread) {
                        $scope.unreadCount++;
                    }
                });
            };

            $scope.$on('debug:notification:create', function (event, data) {
                onNotificationCreate(data);
            });

            console.debug('[NOTIFICATION] $scope', $scope);

            webSocket.on('notification:create', function (data) {
                // Load notifications if list empty.
                if (!$scope.collection.length) {
                    $scope.query(onNotificationCreate, data);
                } else {
                    onNotificationCreate(data);
                }
            });

            function onNotificationCreate(data) {
                console.log('NOTIFICATION RECEIVED', data);

                // data: "{"place":{"id":827,"name":"notification"},"node":{"id":6724,"mark":true}}"

                var notificationId = data.node.id;

                // Retrieves the notification instance
                notificationFactory
                    .read('me', notificationId)
                    .then(function (response) {
                        var responseData = response.data.data;
                        var notificationData = responseData.object;

                        var exists = false;

                        // Try to use new Notification service first to show the notification
                        if (
                            NativeNotificationService.hasFactory(responseData) &&
                            $scope.isNotificationEnable(notificationData.name, 'native')
                        ) {
                            NativeNotificationParamsService.getParams(responseData).then(function (notificationParams) {
                                NativeNotificationService.showNotification(notificationParams);
                            });
                        }

                        var userId = responseData.object.location.owner.id;

                        $scope.collection.forEach(function (item, index) {
                            var removed = false;

                            if (
                                responseData.object.name === 'message' &&
                                item.object.name === 'message' &&
                                item.unread
                            ) {
                                if (item.object.location.owner.id === userId) {
                                    $scope.collection.splice(index, 1);
                                    removed = true;
                                }
                            }

                            if (
                                parseInt(item.object.id) === parseInt(response.data.data.object.id) &&
                                item.object.name === response.data.data.object.name &&
                                item.verb.name === response.data.data.verb.name &&
                                !removed
                            ) {
                                exists = true;
                            }
                        });

                        if (!exists) {
                            ++params.let;

                            $scope.collection.unshift(response.data.data);
                        }

                        $scope.updateUnreadCounter();

                        if (!$scope.$$phase) {
                            $scope.$digest();
                        }
                    })
                    .catch(function (error) {
                        console.warn('Notification could not be found', notificationId);
                        console.error(error);
                    });
            }

            webSocket.on('notification:update', function (data) {
                notificationFactory
                    .read('me', data.node.id)
                    .then(function (response) {
                        var inCollection = false;

                        $scope.collection.forEach(function (item, index) {
                            if (parseInt(item.id) === parseInt(data.node.id)) {
                                inCollection = true;
                                $scope.collection.splice(index, 1);
                            }
                        });

                        if (!inCollection) {
                            ++params.let;
                        }

                        $scope.collection.unshift(response.data.data);

                        $scope.updateUnreadCounter();

                        if (!$scope.$$phase) {
                            $scope.$digest();
                        }
                    })
                    .catch(function () {
                        //
                    });
            });
        },
    ])
    .controller('notificationSettingsController', [
        '$scope',
        'graph-notification-factory',
        function ($scope, notificationFactory) {
            $scope.settings = {
                groupUpdates: {
                    web: true,
                    email: true,
                    mobile: true,
                    native: false,
                },
                eventUpdates: {
                    web: true,
                    email: false,
                    mobile: true,
                    native: false,
                },
                webinarUpdates: {
                    web: true,
                    email: false,
                    mobile: true,
                    native: false,
                },
                friendUpdates: {
                    web: true,
                    email: false,
                    mobile: true,
                    native: false,
                },
                ownContentActivity: {
                    web: true,
                    email: false,
                    mobile: true,
                    native: false,
                },
                privateMessage: {
                    web: true,
                    email: true,
                    mobile: true,
                    native: false,
                },
                streamingInGroup: {
                    web: true,
                    email: false,
                    mobile: true,
                    native: false,
                },
                streamingInWebinar: {
                    web: true,
                    email: false,
                    mobile: true,
                    native: false,
                },
                groupInvitation: {
                    web: true,
                    email: false,
                    mobile: true,
                    native: false,
                },
                eventInvitation: {
                    web: true,
                    email: false,
                    mobile: true,
                    native: false,
                },
                webinarInvitation: {
                    web: true,
                    email: true,
                    mobile: true,
                    native: false,
                },
                friendRequest: {
                    web: true,
                    email: false,
                    mobile: true,
                    native: false,
                },
                webinarReminder: {
                    email: true,
                },
            };

            notificationFactory
                .readSettings('me')
                .then(function (response) {
                    $scope.settings = response.data.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

            $scope.updateSettingKey = function (settingKey, settingType, settingValue) {
                if (settingValue === true) {
                    notificationFactory
                        .enableSettingKey('me', settingKey, settingType)
                        .then(function (response) {
                            // it's okay
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                } else {
                    notificationFactory
                        .disableSettingKey('me', settingKey, settingType)
                        .then(function (response) {
                            // it's okay
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            };
        },
    ])
    .controller('notification-query-ctrl', [
        '$scope',
        'InviteManagerFactory',
        'RequestManagerFactory',
        '$flex',
        'WebSocket',
        function ($scope, InviteManagerFactory, RequestManagerFactory, $flex, WebSocket) {
            $scope.requests = 0;
            $scope.invited = 0;

            angular.extend($scope, $flex.data);

            $scope.space = 'me';

            $scope.Request = RequestManagerFactory.Init(
                $scope.space === 'me' ? $scope.$parent.me.id : $scope.space,
                'user',
                $scope
            );

            $scope.Invite = InviteManagerFactory.Init(
                $scope.space === 'me' ? $scope.$parent.me.id : $scope.space,
                'user',
                $scope
            );

            $scope.init = function (requests, invited) {
                $scope.requests = requests;
                $scope.invited = invited;

                $scope.Request.Count = $scope.requests;
                $scope.Invite.Count = $scope.invited;
            };

            $scope.query = function (next) {
                $scope.Request.Query(next);
                $scope.Invite.Query(next);
            };

            $scope.$on('touch:toolbox:notification', function () {
                $scope.query();
            });

            WebSocket.emit('join:user', [$scope.space === 'me' ? $scope.$parent.me.id : $scope.space]);
        },
    ]);
